


























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Banner from '@/components/banner/Bannerwrap.vue';
import mao from '@/components/banner/mao.vue';

import { hasClass, addClass } from '@/util/domClass.ts';
import getDiffY from '@/util/domGetDiffY.ts';

import imgs from '@/util/imgs.ts';
import Toolbar from '@/components/toolbar/Toolbar.vue';
import axios from 'axios';
import qs from 'qs';
import i18n from '@/plugins/i18n';

declare let BMap: any;

@Component({
  components: {
    Banner,
    Toolbar,
    mao
  },
})
export default class Contact extends Vue {
  // initial data
  private iszoom: boolean = false;
  private imgs = imgs;
  private form = {
    theme:'',
    content:'',
    CompanyType:'',
    CorporateName:'',
    name:'',
    email:'',
    tel:'',
    website: '',
  };
  private rules = {
    theme: [
      { required: true, message: i18n.t('contact_page.formRules.theme'), trigger: 'blur', }
    ],
    content: [
      { required: true, message: i18n.t('contact_page.formRules.content'), trigger: 'blur', }
    ],
    CompanyType: [
      { required: true, message: i18n.t('contact_page.formRules.CompanyType'), trigger: 'blur', }
    ],
    CorporateName: [
      { required: true, message: i18n.t('contact_page.formRules.CorporateName'), trigger: 'blur', }
    ],
    name: [
      { required: true, message: i18n.t('contact_page.formRules.name'), trigger: 'blur', }
    ],
    email: [
      { required: true, message: i18n.t('contact_page.formRules.email'), trigger: 'blur', }
    ],
    tel: [
      { required: true, message: i18n.t('contact_page.formRules.tel'), trigger: 'blur', }
    ],
  };

  // private BMap: any;
  private bmap() {
    const map = new BMap.Map('container');
    // 创建地图实例
    const point = new BMap.Point(121.031912, 30.183634);
    // 创建点坐标
    map.centerAndZoom(point, 17);
    // 初始化地图， 设置中心点坐标和地图级别
    // var marker = new BMap.Marker(point);

    const marker1 = new BMap.NavigationControl();
    const marker2 = new BMap.ScaleControl();
    const marker3 = new BMap.OverviewMapControl();
    const marker4 = new BMap.MapTypeControl();
    const marker5 = new BMap.Marker(point);
    map.addControl(marker1);              // 添加平移缩放控件
    map.addControl(marker2);              // 添加比例尺控件
    map.addControl(marker3);              // 添加缩略地图控件
    // map.enableScrollWheelZoom(marker4); // 启用滚轮放大缩小
    map.addControl(marker5);              // 添加地图类型控件
    // map.centerAndZoom(point, 14);
    // map.addOverlay(marker);
    map.setMapStyle({style: 'grayscale'});
  }

   @Watch('$route')
  private onRouteChanged(to: any) {
    this.fetchUI(to.query);
  }

  @Watch('$store.state.lang')
  private onLangChanged() {
    this.fetchData();
  }

  private mounted() {
    this.$store.dispatch('setToolbarItems', [
      {
        name: '联系',
        active: '1',
        href: '/#/contact?section=1',
      },
      {
        name: '在线讯盘',
        active: '2',
        href: '/#/contact?section=2',
      },
    ]);
    this.$nextTick(() => {
      this.fetchUI(this.$route.query);
      this.iszoom = true;
    });
    this.bmap();
  }

  private submitForm(query: any) {
    (this.$refs['form'] as any).validate((valid: any) => {
          if (valid) {
            axios({
              method: 'post',
              url: 'http://dentik.sansg.com/php/form.php',
              data: qs.stringify(this.form)
            }).then((res: any) => {
              this.form={
                theme:'',
                content:'',
                CompanyType:'',
                CorporateName:'',
                name:'',
                email:'',
                tel:'',
                website: '',
              };
              /* this.$message({
                message: i18n.t('contact_page.success'),
                type: 'success',
              }); */
              this.closeDialog();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });

  }
  private fetchUI(query: any) {
    let section = '1';
    let noscroll = false;

    if (query) {
      // window.console.log('query.noscroll:', query.noscroll);
      noscroll = query.noscroll || false;
      section = query.section || '1';
    }

    this.$store.dispatch('setToolbarActive', section);

    this.fetchData();
  }
  private closeDialog() {
    this.$router.push({
      name: 'contact',
      query: {
        section: '1'
      }
    });
  }

  private fetchData() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    if (this.$store.state.toolbarActive === '2') {

    }
    if (this.$store.state.lang === 'en') {
      this.$store.dispatch('setToolbarItems', [
      {
        name: 'Contact',
        active: '1',
        href: '/#/contact?section=1',
      },
      {
        name: 'Online Inquiry',
        active: '2',
        href: '/#/contact?section=2',
      },
    ]);
    } else {
      this.$store.dispatch('setToolbarItems', [
      {
        name: '联系',
        active: '1',
        href: '/#/contact?section=1',
      },
      {
        name: '在线询盘',
        active: '2',
        href: '/#/contact?section=2',
      },
    ]);
    }
  }

  private handleScroll(evt: any, el: any) {
    // 如果 el 已经运行过动画了
    if (hasClass(el, 'animated')) {
      return false;
    }

    // const { top } = el.getBoundingClientRect()
    // // 当前元素距离顶部的距离
    // window.console.log('el top: ', top)
    // // 浏览器窗口的视口的高度
    // window.console.log('视口高度: ', window.innerHeight)
    const diff = getDiffY(el);

    if (diff > 50) {
      addClass(el, 'animated');
    }
    return diff > 50;
  }
}
